import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  Typography,
} from "@mui/material";
import { IFormProps } from "types/form-props";
import RHFTextValue from "components/minimal/hook-form/rhf-text-value";
import { fDate } from "utils/format-time";
import RHFRadioGroup from "components/minimal/hook-form/rhf-radio-group";
import { useState } from "react";
import PreviewMedia from "components/common/preview-media/preview-media";
import { RADIO_Status_OPTIONS } from "./story-report-column";

interface StoryReportFormProps extends IFormProps {}

const StoryReportForm: React.FC<StoryReportFormProps> = ({
  currentItem: rowData,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const toggleForm = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <Grid item xs={12}>
        <Card>
          <CardHeader title="Story Report Information" />
          <Divider />
          <CardContent>
            <RHFTextValue label="User" value={rowData?.user?.fullName} />
            {rowData?.user?.blocked && rowData?.user?.isActive && (
              <p style={{ color: "red", fontWeight: "bold" }}>
                Reporter isBlocked
              </p>
            )}
            {!rowData?.user?.isActive && (
              <p style={{ color: "red", fontWeight: "bold" }}>
                Reporter isDeleted
              </p>
            )}

            <RHFTextValue label="Reporter Type" value={rowData?.reporterType} />
            <RHFTextValue
              label="Story Status"
              value={rowData?.userStory?.deletedAt ? "Deleted" : "UnDeleted"}
            />
            <RHFTextValue label="Category" value={rowData?.category} />
            <RHFTextValue
              label="Media Type"
              value={rowData?.userStory?.mediaType?.label}
            />
            <RHFTextValue label="Reason" value={rowData?.reason} />
            <RHFTextValue
              label="Created Date"
              value={fDate(rowData?.createdAt)}
            />
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12}>
        <RHFTextValue
          label="Media Link"
          value={
            <Typography
              sx={{ textDecoration: "underline", cursor: "pointer" }}
              fontWeight={500}
              onClick={toggleForm}
            >
              Preview
            </Typography>
          }
        />
      </Grid>
      <Grid item xs={12}>
        <RHFRadioGroup
          label="Status"
          name="status"
          options={RADIO_Status_OPTIONS()}
          sx={{ display: "flex", flexDirection: "row" }}
          disabled={rowData?.status === "APPROVED"}
        />
      </Grid>
      <PreviewMedia
        urlMedia={rowData?.userStory?.mediaUrl}
        mediaType={rowData?.userStory?.mediaType?.label}
        isOpen={isOpen}
        toggleForm={toggleForm}
      />
    </>
  );
};

export default StoryReportForm;
